import Views from './views';

export default Views;
